// extracted by mini-css-extract-plugin
export var aboveInput = "_nx-0";
export var actionButton = "_nx-5";
export var actionButtonContainer = "_nx-1";
export var actionIcon = "_nx-6";
export var aiInfoContainer = "_nx-2";
export var attachmentWrapper = "_nx-7";
export var bold = "_nx-3";
export var checkIcon = "_nx-8";
export var clickingRecipientBar = "_nx-11";
export var commentThreadSwitch = "_nx-a";
export var draftImage = "_nx-b";
export var draftImageContainer = "_nx-c";
export var draftImages = "_nx-e";
export var editButton = "_nx-g";
export var editor = "_nx-f";
export var editorContainer = "_nx-y";
export var editorErrorTooltipWrapper = "_nx-9";
export var headerDivider = "_nx-h";
export var icon = "_nx-i";
export var info = "_nx-j";
export var internal = "_nx-n";
export var internalDivider = "_nx-k";
export var internalMessage = "_nx-l";
export var messageInputCard = "_nx-m";
export var messageInputForm = "_nx-o";
export var messageInputFormInternal = "_nx-p";
export var options = "_nx-q";
export var publicMessageCustomer = "_nx-s";
export var publicMessageMerchant = "_nx-r";
export var removeImageButton = "_nx-d";
export var replyButtons = "_nx-t";
export var showSignatureButton = "_nx-u";
export var spinner = "_nx-v";
export var verticalButtonDivider = "_nx-4";
export var visibilitySelector = "_nx-w";
export var warning = "_nx-x";
export var wrappingText = "_nx-z";
export var writingInternalNoteTopBorder = "_nx-10";